import { RpcUpdate } from '~/post/types';

export type CampaignChannel = {
  serviceId: string;
  serviceType: string;
  channelType: string;
  channelId: string;
  serviceAvatar: string;
  serviceUsername: string;
  isManager: boolean;
  hasPushNotifications: boolean;
};

export enum CampaignColor {
  Purple = '#9C2BFF',
  Pink = '#D925AC',
  PinkLighter = '#F0A8DE',
  Orange = '#FF702C',
  Yellow = '#FADE2A',
  Green = '#87C221',
  Teal = '#00C8CF',
  BlueDark = '#1F35B3',
  Black = '#000000',
}

export type Campaign = {
  id: string;
  name: string;
  color: CampaignColor;

  globalOrganizationId: string;
  lastUpdated: string;
  updatedAt: number;
  createdAt: number;
  startDate: number;
  endDate: number;
  dateRange: string | null;
  sent: number;
  scheduled: number;
  draftsCount: number;
  approvalsCount: number;
  isAggregation?: boolean;
  channels: CampaignChannel[] | [];
  items: CampaignItem[] | [];
};

export type CampaignDetails = {
  id: string;
  name: string;
  color: CampaignColor;
  startDate?: number;
  endDate?: number;
  /** Human readable date of campaign. E.g., 'Oct 11-13' */
  formattedDateRange?: string;
};

export type HeaderDetailsChannel = {
  avatarUrl: string;
  handle: string;
  type: string;
};

export type HeaderDetails = {
  channel?: HeaderDetailsChannel;
  creatorName?: string;
  avatarUrl: string;
  createdAt: string;
  hideCreatorDetails?: boolean;
};

export type CampaignItem = RpcUpdate & {
  headerDetails: HeaderDetails;
};

export enum CampaignTab {
  Scheduled = 'scheduled',
  Sent = 'sent',
  Drafts = 'draft',
  Approvals = 'draft_pending',
}

export enum CtaLocation {
  EmptyDraftsTab = 'emptyDraftsTab',
  EmptyScheduledTab = 'emptyScheduledTab',
  CampaignHeader = 'campaignHeader',
}

export type CampaignListItem = {
  color?: CampaignColor;
  id: string;
  name: string;
  sent: number;
  scheduled: number;
  lastUpdated: string;
  dateRange?: string;
  draftsCount?: number;
  approvalsCount?: number;
};
